import script from "./CookieBanner.component.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieBanner.component.vue?vue&type=script&setup=true&lang=js"

import "./CookieBanner.component.vue?vue&type=style&index=0&id=4449f01f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4449f01f"]])

export default __exports__